import { useSelector } from "react-redux";
import { selectProgramId } from "../../Store/api/program/programSelectors";
import { useGetProgramSettingBySettingNameQuery } from "../../Store/api/apiSlice";
import { SettingNames } from "../../MPP-Common-SPA/programSettings/enums";


export const useProgramSettingsInfo = (settingName) => {
  const programId = useSelector(selectProgramId);
  // DEV Note: ProgramSettingController has a list of settings that are allowed to be retrieved.  
  const { data: setting } = useGetProgramSettingBySettingNameQuery(
    {
      settingName: settingName,
      programId,
    },
    { skip: !programId },
  );

  try {
    const config = JSON.parse(setting?.configuration || '{}');
    // currently there are only two settings being used.  If we need to add more, we can create a switch case OR drive with parameter to change return type.
    if (settingName === SettingNames.PublicNotificationsSupportInformation) return config?.Content || ""; // return string

    return config; // return object
  } catch {
    return {};
  }
};
